// pages/dashboard/page.jsx
// ─────────────────────────────────────────────────────────────
// Now a pure configuration file — no rendering logic.
// AdminLayout.jsx handles the shell; routes.jsx handles rendering.
// This file exports the permission map and the nav↔path maps that
// both AdminLayout and Sidebar need to share.
// ─────────────────────────────────────────────────────────────

// ── Permission → view mapping ─────────────────────────────────
// null = any authenticated admin can access
export const VIEW_PERMISSIONS = {
  dashboard:        null,
  analytics:        "view_analytics",
  transactions:     "manage_transactions",
  users:            "manage_users",
  kyc:              "manage_kyc",
  assets:           "manage_assets",
  wallets:          "manage_wallets",
  dataPlans:        "manage_assets",
  campaign:         "manage_marketing",
  alerts:           "view_alerts",
  notifications:    "manage_settings",
  tickets:          "manage_kyc",
  services_settings:"manage_services",
  general_settings: "manage_settings",
  onboarding_slide: "manage_settings",
  accounts:         "manage_admins",
  settings:         "manage_settings",
  catalog:          "manage_assets",
  companies:        "manage_transactions",
  savings_settings: "manage_settings",
  reward_rules:     "manage_settings",
  fraud:            "manage_transactions",
  provider_balances:"manage_services",
  audit_logs:       "manage_settings",
  countries:         "manage_settings",
  providers:        "manage_services",
  coupon:           "manage_assets",
  marketing_slides: "manage_marketing",
  promo_codes:      "manage_marketing",
};

// ── Nav ID → URL path ─────────────────────────────────────────
// Sidebar uses this to navigate; AdminLayout uses it for handleNavChange.
export const NAV_TO_PATH = {
  dashboard:        "/dashboard",
  analytics:        "/analytics",
  transactions:     "/transactions",
  users:            "/users",
  kyc:              "/kyc",
  assets:           "/assets",
  wallets:          "/wallets",
  dataPlans:        "/data-plans",
  campaign:         "/marketing",
  alerts:           "/alerts",
  notifications:    "/notifications",
  tickets:          "/tickets",
  services_settings:"/services",
  general_settings: "/app-settings",
  onboarding_slide: "/onboarding",
  accounts:         "/accounts",
  settings:         "/settings",
  providers:        "/providers",
  coupon:           "/coupons",
  marketing_slides: "/marketing-slides",
  catalog:          "/catalog",
  companies:        "/companies",
  savings_settings: "/savings-settings",
  reward_rules:     "/reward-rules",
  fraud:            "/fraud",
  provider_balances:"/provider-balances",
  audit_logs:       "/audit-logs",
  countries:         "/countries",
  promo_codes:      "/promo-codes",
};

// ── URL path segment → nav ID (reverse of NAV_TO_PATH) ────────
// AdminLayout derives activeNav from location.pathname using this.
export const PATH_TO_NAV = Object.fromEntries(
  Object.entries(NAV_TO_PATH).map(([id, path]) => [path.replace(/^\//, ""), id])
);

// ── Permission checker ────────────────────────────────────────
export function hasPermission(adminPermissions = [], permission) {
  if (!permission) return true;
  return adminPermissions.includes(permission);
}